window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Collections ??= {};

AppointmentBooking.SlotSuggester.Collections.Base = class Base extends Backbone.Collection {};
